export default "__VITE_ASSET__Bk0euIxB__"